import template from './template.html';
import blockBase from "../../mixins/blockBase";
require('jcf/dist/js/jcf');
require('jcf/dist/js/jcf.select');

export default {
    name: 'contact',
    template: template,
    mixins: [
        blockBase,
    ],
    methods: {
        initSelect() {
            jcf.setOptions('Select', {
                wrapNative: false,
                wrapNativeOnMobile: false
            });
            jcf.replaceAll();
        },
        initCF7() {
            $(this.$refs.holder).find('.wpcf7-form').each(function (index, elem) {
                wpcf7.init(elem);

                if (wpcf7.cached) {
                    wpcf7.refill(elem);
                }
            });
        }
    },
    mounted() {
        const vm = this;
        $(document).ready(function() {
            vm.initSelect();
            vm.initCF7();
        });
    }
};